var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrows4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130.6 29.2",
    style: {
      enableBackground: "new 0 0 130.6 29.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000065051570581980769360000012278429709956846473_);}\n\t.st2{fill:url(#SVGID_00000012447071784903177750000015703153746057512885_);}\n\t.st3{fill:url(#SVGID_00000059294184436649876250000017046745062195628451_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.7603,
    y1: -11.7906,
    x2: 131.9031,
    y2: -11.7906,
    gradientTransform: "matrix(0.9991 4.130000e-02 -4.130000e-02 0.9991 -1.1564 22.3008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A93749"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,0.5c0,0,1.2,9.2,2.4,13.6c0,0,5.4,4.5,21,5.7c15.6,1.2,18,1.1,21.3,2.2c3.3,1.1,8.4,7.2,8.4,7.2 s-4.7-11.3-8.5-14.9l1.1,2.2c0,0-2.3-1.4-4.2-2.2c-1.9-0.8-20.9-4-29.5-7.2C84.7,5.3,77.6,0.5,77.6,0.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057844900522017979400000006293785382742068128_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.6289,
    y1: -18.4995,
    x2: 80.6978,
    y2: -18.4995,
    gradientTransform: "matrix(0.9991 4.130000e-02 -4.130000e-02 0.9991 -1.1564 22.3008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A93749"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057844900522017979400000006293785382742068128_)"
    },
    d: "M79.9,14.1c0,0-4.4-9.7-4.5-14.1l1,0 C76.5,0,79.1,12.2,79.9,14.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170989237889890045010000003255254904245342090_",
    gradientUnits: "userSpaceOnUse",
    x1: -1298.5226,
    y1: 45.1011,
    x2: -1244.3798,
    y2: 45.1011,
    gradientTransform: "matrix(-0.9991 4.130000e-02 4.130000e-02 0.9991 -1245.6699 22.3008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A93749"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170989237889890045010000003255254904245342090_)"
    },
    d: "M53,0.5c0,0-1.2,9.2-2.4,13.6 c0,0-5.4,4.5-21,5.7C14,21,11.6,20.9,8.4,22C5.1,23.1,0,29.2,0,29.2s4.7-11.3,8.5-14.9l-1.1,2.2c0,0,2.3-1.4,4.2-2.2 c1.9-0.8,20.9-4,29.5-7.2C45.9,5.3,53,0.5,53,0.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065774799746203769280000015887722864942015629_",
    gradientUnits: "userSpaceOnUse",
    x1: -1300.6541,
    y1: 38.3922,
    x2: -1295.5852,
    y2: 38.3922,
    gradientTransform: "matrix(-0.9991 4.130000e-02 4.130000e-02 0.9991 -1245.6699 22.3008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#751540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A93749"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065774799746203769280000015887722864942015629_)"
    },
    d: "M50.6,14.1c0,0,4.4-9.7,4.5-14.1l-1,0 C54.1,0,51.5,12.2,50.6,14.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrows4);
export default __webpack_public_path__ + "static/media/Brows4.4d95267c746167d37c47c3af4a0f36d2.svg";
export { ForwardRef as ReactComponent };